import { create } from "zustand"

type DeviceInfoStore = {
  deviceName?: string
  appName?: string
  pushId?: string
  setDeviceName: (deviceName: string) => void
  setAppName: (appName: string) => void
  setPushId: (pushId: string) => void
}

export const useDeviceInfoStore = create<DeviceInfoStore>((set) => ({
  deviceName: undefined,
  appName: undefined,
  pushId: undefined,
  setDeviceName: (deviceName) => set({ deviceName }),
  setAppName: (appName) => set({ appName }),
  setPushId: (pushId) => set({ pushId }),
}))
